/* 위젯 — 외부 사이트와 CSS 격리 위해 모든 룰을 #allsteel-chat-root 안에 한정. */
#allsteel-chat-root,
#allsteel-chat-root * {
  box-sizing: border-box;
  font-family: -apple-system, 'Apple SD Gothic Neo', 'Pretendard', system-ui, sans-serif;
}
#allsteel-chat-root {
  --asc-primary: #2563eb;
  --asc-primary-dark: #1d4ed8;
  --asc-ink: #0f172a;
  --asc-ink-soft: #475569;
  --asc-line: #e2e8f0;
  --asc-bg: #f8fafc;
  --asc-bubble-them: #f1f5f9;
  --asc-bubble-me: #2563eb;
  color: var(--asc-ink);
  line-height: 1.5;
  font-size: 14px;
}

/* 런처 — 알약 형태 (텍스트 + 아이콘) */
.asc-launcher {
  position: fixed;
  right: 20px;
  bottom: 20px;
  background: #FAC484;
  color: #3a1d1d;
  border: none;
  border-radius: 999px;
  padding: 12px 20px 12px 16px;
  cursor: pointer;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.18);
  z-index: 2147483646;
  display: inline-flex;
  align-items: center;
  gap: 12px;
  transition: transform 0.18s, box-shadow 0.18s;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.2;
  white-space: nowrap;
}
.asc-launcher:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.24);
}
.asc-launcher:active { transform: translateY(0); }
.asc-launcher-icon {
  width: 30px; height: 30px;
  display: block;
  background: white;
  border-radius: 50%;
  padding: 5px;
  box-sizing: border-box;
  color: #FAC484;
}
.asc-launcher-text {
  display: inline-block;
}
.asc-launcher-sub {
  font-size: 12px;
  font-weight: 500;
  color: #6b4423;
  display: flex;
  align-items: center;
  gap: 5px;
}
.asc-launcher-sub::before {
  content: '';
  width: 7px; height: 7px;
  background: #16a34a;
  border-radius: 50%;
  display: inline-block;
}
.asc-launcher-textblock {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
}
.asc-launcher-badge {
  position: absolute;
  top: -6px; right: -6px;
  background: #ef4444;
  color: white;
  border-radius: 999px;
  padding: 2px 7px;
  font-size: 11px;
  font-weight: bold;
  min-width: 20px;
  text-align: center;
  border: 2px solid white;
  box-sizing: content-box;
}

/* 모바일 — 좁아도 한 줄 유지 */
@media (max-width: 480px) {
  .asc-launcher { padding: 11px 16px 11px 14px; font-size: 15px; gap: 10px; }
  .asc-launcher-icon { width: 26px; height: 26px; padding: 4px; }
  .asc-launcher-sub { font-size: 11.5px; }
  .asc-launcher-textblock { gap: 5px; }
}

/* (구) 인사말 말풍선 — launcher 알약에 통합되어 폐기 (2026-05-30) */

/* 패널 (PC: 사이드 / 모바일: 풀스크린) */
.asc-panel {
  position: fixed;
  z-index: 2147483647;
  background: white;
  display: flex;
  flex-direction: column;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
}
@media (min-width: 641px) {
  .asc-panel {
    right: 18px; bottom: 18px;
    width: 380px; height: min(640px, calc(100vh - 36px));
    border-radius: 14px; overflow: hidden;
  }
}
@media (max-width: 640px) {
  .asc-panel {
    inset: 0;
    width: 100vw;
    /* 모바일 주소창·키보드 영역 고려 — dvh 우선, fallback vh */
    height: 100vh;
    height: 100dvh;
    border-radius: 0;
    min-height: 0;
  }
}

/* 헤더 */
.asc-head {
  background: var(--asc-primary);
  color: white;
  padding: 14px 16px;
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.asc-head-title { font-weight: bold; font-size: 15px; }
.asc-head-sub { font-size: 11px; opacity: 0.85; margin-top: 2px; }
.asc-head-x {
  margin-left: auto;
  background: rgba(255, 255, 255, 0.15);
  color: white; border: 0; width: 28px; height: 28px; border-radius: 50%;
  cursor: pointer; font-size: 16px;
}

/* 메시지 영역 */
.asc-body {
  flex: 1 1 0;
  min-height: 0;  /* flex 자식이 컨텐츠 크기로 부풀어 input 가리는 것 방지 */
  overflow-y: auto;
  padding: 14px;
  background: var(--asc-bg);
}
/* 입력 영역은 절대 줄어들지 않게 */
.asc-input {
  flex-shrink: 0;
}
/* 드래그앤드롭 인디케이터 */
.asc-panel.asc-dragover { outline: 3px dashed var(--asc-primary); outline-offset: -8px; }
.asc-panel.asc-dragover::after {
  content: '여기에 놓으면 이미지 업로드';
  position: absolute;
  top: 50%; left: 50%; transform: translate(-50%, -50%);
  background: var(--asc-primary); color: white;
  padding: 12px 20px; border-radius: 12px;
  font-weight: bold; font-size: 14px;
  pointer-events: none;
  z-index: 1;
}
.asc-msg-row { margin-bottom: 10px; display: flex; align-items: flex-end; gap: 6px; }
.asc-msg-row.them { justify-content: flex-start; }
.asc-msg-row.me { justify-content: flex-end; }
.asc-avatar {
  width: 28px; height: 28px;
  background: #FAC484;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  flex-shrink: 0;
}
.asc-msg-col { display: flex; flex-direction: column; max-width: 78%; }
.asc-bubble {
  max-width: 80%;
  padding: 9px 12px;
  border-radius: 14px;
  word-break: break-word;
  white-space: pre-wrap;
  font-size: 13.5px;
}
.them .asc-bubble {
  background: white;
  border: 1px solid var(--asc-line);
  border-top-left-radius: 4px;
}
.me .asc-bubble {
  background: var(--asc-bubble-me);
  color: white;
  border-top-right-radius: 4px;
}
.asc-bubble a { color: inherit; text-decoration: underline; }
.me .asc-bubble a { color: #cfe2ff; }
.asc-bubble img.asc-attach,
img.asc-attach {
  display: block; max-width: 100%; border-radius: 8px; margin-top: 6px;
  cursor: zoom-in;
  transition: transform 0.15s;
}
img.asc-attach:hover { transform: scale(1.02); }

/* 라이트박스 (이미지 클릭 시 풀스크린) */
.asc-lightbox {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.85);
  z-index: 2147483647;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  cursor: zoom-out;
  animation: asc-fade-in 0.18s;
}
@keyframes asc-fade-in { from { opacity: 0 } to { opacity: 1 } }
.asc-lightbox img {
  max-width: 96vw;
  max-height: 92vh;
  border-radius: 6px;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.5);
}
.asc-lightbox-x {
  position: absolute;
  top: 16px; right: 20px;
  background: rgba(255, 255, 255, 0.15);
  color: white;
  border: 0;
  width: 40px; height: 40px;
  border-radius: 50%;
  font-size: 24px;
  cursor: pointer;
}
.asc-lightbox-x:hover { background: rgba(255, 255, 255, 0.25); }
.asc-msg-meta {
  font-size: 10px; color: var(--asc-ink-soft); margin-top: 3px;
}
.them .asc-msg-meta { text-align: left; }
.me .asc-msg-meta { text-align: right; }

.asc-greet {
  background: white; border: 1px solid var(--asc-line); border-radius: 12px;
  padding: 14px; font-size: 13px; color: var(--asc-ink-soft); margin-bottom: 12px;
}
.asc-greet-title { font-weight: bold; color: var(--asc-ink); margin-bottom: 4px; }
.asc-greet-hours { font-size: 11px; margin-top: 6px; }

/* 연락처 폼 */
.asc-identify {
  background: white; border: 1px solid var(--asc-line); border-radius: 12px;
  padding: 14px; margin-bottom: 12px;
}
.asc-identify-title { font-weight: bold; font-size: 13px; margin-bottom: 6px; }
.asc-identify-desc { font-size: 12px; color: var(--asc-ink-soft); margin-bottom: 10px; line-height: 1.5; }
.asc-identify input {
  width: 100%; padding: 8px 10px; border: 1px solid var(--asc-line);
  border-radius: 8px; font-size: 14px; margin-bottom: 8px;
}
.asc-identify-btn {
  width: 100%; background: var(--asc-primary); color: white; border: 0;
  padding: 10px; border-radius: 8px; font-weight: bold; cursor: pointer; font-size: 14px;
}
.asc-identify-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.asc-identify-skip {
  display: block; width: 100%; background: none; border: 0; color: var(--asc-ink-soft);
  font-size: 12px; padding: 6px; cursor: pointer; margin-top: 4px;
}

/* 입력 */
.asc-input {
  border-top: 1px solid var(--asc-line);
  padding: 10px 12px;
  background: white;
  display: flex;
  gap: 8px;
  align-items: flex-end;
}
.asc-input textarea {
  flex: 1; resize: none;
  border: 1px solid var(--asc-line); border-radius: 18px;
  padding: 9px 14px; font-size: 14px; line-height: 1.4;
  max-height: 100px; min-height: 36px;
  font-family: inherit;
}
.asc-input textarea:focus { outline: 2px solid var(--asc-primary); outline-offset: -1px; }
.asc-input-btn {
  background: var(--asc-primary); color: white; border: 0;
  width: 36px; height: 36px; border-radius: 50%; cursor: pointer;
  display: inline-flex; align-items: center; justify-content: center;
  font-size: 16px; flex-shrink: 0;
}
.asc-input-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.asc-input-attach {
  background: none; border: 0; color: var(--asc-ink-soft);
  cursor: pointer; padding: 6px; flex-shrink: 0; font-size: 18px;
}
.asc-input-attach input { display: none; }
.asc-uploading {
  font-size: 11px; color: var(--asc-primary); padding: 0 12px 6px;
}
.asc-error {
  background: #fef2f2; color: #991b1b; padding: 8px 12px; font-size: 12px;
  border-top: 1px solid #fecaca;
}
